import { useAppDataStore } from '@/stores/app'
import type { ServiceClassInterface } from '@/types/trips'

interface SortableItem {
  sortValue?: number | null
  dateScheduled?: string | null
  dateValidFrom?: string | null
}

export const handleErrorResponse = (error: unknown) => {
  const err = error as { response?: { status?: number }; status?: number }
  if ((err?.response?.status ?? err?.status) === 401) {
    console.warn("❌ WARNING:", error);
    window.location.reload();
    return;
  }
}
export const handleError = (error: unknown) => {
  const appData = useAppDataStore();
  const err = error as { message?: string }

  if (err?.message) {
    console.error("❌ ERROR:", error);
    appData.$patch({
      notifications: {
        errors: [
          ...appData.notifications.errors,
          err.message,
        ],
      }
    })
  }
}

// The class a line item or a price threshold names when its service no longer offers it. A class that trips use is
// retired, not deleted, when its service drops it: they keep it, but the service stops listing it.
export const retiredClassification = (
  current: ServiceClassInterface | null | undefined,
  offered: ServiceClassInterface[] | undefined,
): ServiceClassInterface | null => {
  if (!current?.uuid) return null
  if (offered?.some(classification => classification.uuid === current.uuid)) return null

  return current
}

export const stripHtml = (html: string|null) => {
  const tmp = document.createElement("DIV");
  tmp.innerHTML = html ?? "";
  return tmp.textContent || tmp.innerText || "";
}

export const dateSorter = (element1: SortableItem, element2: SortableItem) => {
  if (element1.sortValue && element2.sortValue) {
    if (element1.sortValue < element2.sortValue) {
      return -1;
    }

    if (element1.sortValue > element2.sortValue) {
      return 1;
    }
  }
  else {
    const date1 = new Date(element1.dateScheduled ?? element1.dateValidFrom ?? "");
    const date2 = new Date(element2.dateScheduled ?? element2.dateValidFrom ?? "");

    if (date1 < date2) {
      return -1
    }

    if (date1 > date2) {
      return 1;
    }
  }

  return 0;
}
